import { Component, OnInit, ViewChild, AfterViewInit, ViewEncapsulation, Input } from '@angular/core';
import { DispatchesService } from '../../../shared/services/dispatches.service';
import { GlobalsService } from '../../../shared/services/globals.service';
import { Subscription } from 'rxjs';
import { SelectionEvent } from '@progress/kendo-angular-grid';
import { BaseGridUIComponent } from '../../../shared/base-components/base-grid-ui.component';
import { DisplayNote } from '../../models/DisplayNote';
import { FeatureFlagService } from '../../services/feature-flag.service';

@Component({
  selector: 'display-notes',
  templateUrl: './display-notes.component.html',
  styleUrls: ['./display-notes.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class DisplayNotesComponent extends BaseGridUIComponent<DisplayNote, null, null>  {

  constructor(globals: GlobalsService) {
    super(globals);
  }
}
